
import {trigger, state, animate, style, transition, animation, keyframes, group} from '@angular/animations';

export { slideToBottom, slideToLeft, slideToRight, slideToTop, slideForwardsAndBackwards }

function slideForwardsAndBackwards() {
  return trigger('animationState', [
    state('void', style({position: 'absolute'})),
    state('*', style({})),
    state('forwards', style({transform: 'translateX(-50%)'})),
    state('backwards', style({transform: 'translateX(-50%)'})),
    transition('void => forwards', [
      style({transform: 'translateX(200vw)'}),
      animate('0.5s ease', style({transform: 'translateX(-50%)'}))
    ]),
    transition('void => backwards', [
      style({transform: 'translateX(-200vw)'}),
      animate('0.5s ease', style({transform: 'translateX(-50%)'}))
    ]),
    transition('forwards => void', [
      style({position: 'absolute', transform: 'translateX(-50%)'}),
      animate('0.5s ease', style({transform: 'translateX(-250%)'}))
    ]),
    transition('backwards => void', [
      style({position: 'absolute', transform: 'translateX(-50%)'}),
      animate('0.5s ease', style({transform: 'translateX(250%)'}))
    ])
  ]);
}

function slideToRight() {
  return trigger('routerTransition', [
    state('void', style({position: 'fixed', width: '100%'}) ),
    state('*', style({position: 'fixed', width: '100%'}) ),
    transition(':enter', [
      style({transform: 'translateX(-100%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(0%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateX(0%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(100%)'}))
    ])
  ]);
}

function slideToLeft() {
  return trigger('routerTransition', [
    state('void', style({position: 'fixed'}) ),
    state('*', style({position: 'fixed', transform: 'translateX(-50%)'}) ),
    transition(':enter', [
      style({transform: 'translateX(150%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(-50%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateX(-50%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(-300%)'}))
    ])
  ]);
}

function slideToBottom() {
  return trigger('routerTransition', [
    state('void', style({position: 'fixed', width: '100%', height: '100%'}) ),
    state('*', style({position: 'fixed', width: '100%', height: '100%'}) ),
    transition(':enter', [
      style({transform: 'translateY(-100%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateY(0%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateY(0%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateY(100%)'}))
    ])
  ]);
}

function slideToTop() {
  return trigger('routerTransition', [
    state('void', style({position: 'fixed', width: '100%', height: '100%'}) ),
    state('*', style({position: 'fixed', width: '100%', height: '100%'}) ),
    transition(':enter', [
      style({transform: 'translateY(100%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateY(0%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateY(0%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateY(-100%)'}))
    ])
  ]);
}

// this is a pretty good article, if more reusability+customization is needed.
// https://www.c-sharpcorner.com/article/overview-of-angular-animation/
/*
  Precedence for variable values happen in the following order:
  - values set in the options.params object, which can be set on init or controlled dynamically at run time
  - values passed as arguments to this function when called in the decorator
  - the default values seen in argument above and params objects below

  values passed to params will override values passed to the argument of the function
*/
export function detailExpand(duration: string = '225ms') {
  return trigger('detailExpand', [
    state(
      'collapsed',
      style({
        height: '{{ collapsedHeight }}px',
        minHeight: '{{ collapsedHeight }}px',
        overflow: 'hidden',
        visibility: '{{ visibilityWhenCollapsed }}'
      }),
      {
        params: {
          collapsedHeight: 0,
          visibilityWhenCollapsed: 'hidden' // templating syntax  does not support ternary, have to pass literal striing value
        }
      }
    ),
    state('expanded', style({ height: '*', visibility: 'visible', overflowY: 'visible' })),
    transition(
      'expanded => collapsed',
      group([ // order of this group matters. see drawer.component.scss
        animate('{{duration}} steps(1, start)', style({ overflowY: 'hidden' })),
        animate('{{duration}}  cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ]),
      { params: { duration: duration } }
    ),
    transition(
      'collapsed => expanded',
      group([ // order of this group matters. see drawer.component.scss
        animate('{{duration}}  cubic-bezier(0.4, 0.0, 0.2, 1)'),
        animate('{{duration}} steps(1, end)', style({ overflow: 'visible' })), // allow position absolute elements to escape list-card (tooltip)
      ]),

      { params: { duration: duration } }
    ),
  ])
}

export function fadeInOut(duration: string = '225ms') {
  return trigger('fadeInOut', [
    state('hidden', style({ opacity: 0, visibility: 'hidden' })),
    state('visible', style({ opacity: 1, visibility: 'visible' })),
    transition('hidden <=> visible', animate(`${duration}  cubic-bezier(0.4, 0.0, 0.2, 1)`)),
  ])
}


  // element must have  display: block;
export function bounce(delay = '0ms') {
  return trigger('bounce', [
    transition('void => *', style({})), // avoid animation when component comes into existence, handle explicitly
    transition('* => *',
      animate('750ms {{delay}} ease-out',
        keyframes([
          style({ transform: 'translateY(-1px)' }),
          style({ transform: 'translateY(-6px)' }),
          style({ transform: 'translateY(2px)' }),
          style({ transform: 'translateY(-1px)' }),
          style({ transform: 'translateY(0)' }),
        ])),
      { params: { delay } }
    )
  ])
}
